var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.031 0.469013C11.1008 0.538682 11.1563 0.621445 11.1941 0.712563C11.2319 0.803681 11.2513 0.901362 11.2513 1.00001C11.2513 1.09866 11.2319 1.19635 11.1941 1.28746C11.1563 1.37858 11.1008 1.46134 11.031 1.53101L2.5605 10L11.031 18.469C11.1718 18.6098 11.2509 18.8008 11.2509 19C11.2509 19.1992 11.1718 19.3902 11.031 19.531C10.8902 19.6718 10.6992 19.751 10.5 19.751C10.3008 19.751 10.1098 19.6718 9.969 19.531L0.968998 10.531C0.899153 10.4613 0.843738 10.3786 0.805928 10.2875C0.768119 10.1963 0.748657 10.0987 0.748657 10C0.748657 9.90136 0.768119 9.80368 0.805928 9.71256C0.843738 9.62145 0.899153 9.53868 0.968998 9.46901L9.969 0.469013C10.0387 0.399168 10.1214 0.343754 10.2125 0.305944C10.3037 0.268135 10.4013 0.248672 10.5 0.248672C10.5986 0.248672 10.6963 0.268135 10.7874 0.305944C10.8786 0.343754 10.9613 0.399168 11.031 0.469013Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.1f249be6d884cf009e7ce758a32a5882.svg";
export { ForwardRef as ReactComponent };